import { render, staticRenderFns } from "./ActiveRegulation.vue?vue&type=template&id=258379b0&scoped=true&"
import script from "./ActiveRegulation.vue?vue&type=script&lang=js&"
export * from "./ActiveRegulation.vue?vue&type=script&lang=js&"
import style0 from "./ActiveRegulation.vue?vue&type=style&index=0&id=258379b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258379b0",
  null
  
)

export default component.exports